import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { get } from "@/lib/api";
import { KatlasReceiptCard } from "@/components/KatlasReceiptCard";
import { IllustrativeBadge } from "@/components/IllustrativeBadge";
import { ArrowLeft, Loader2, SearchX } from "lucide-react";

export default function ReceiptPublic() {
  const { hash } = useParams();
  const [receipt, setReceipt] = useState(null);
  const [state, setState] = useState("loading");

  useEffect(() => {
    get(`/r/${encodeURIComponent(hash)}`)
      .then((d) => { setReceipt(d); setState("done"); })
      .catch(() => setState("notfound"));
  }, [hash]);

  return (
    <div className="mx-auto max-w-2xl px-5 py-12 sm:px-8" data-testid="receipt-public">
      <Link to="/" className="mb-6 inline-flex items-center gap-1.5 text-sm font-medium text-mill-muted hover:text-mill-ink" data-testid="receipt-back">
        <ArrowLeft className="h-4 w-4" /> Back to the canvas
      </Link>

      <div className="mb-5 flex flex-wrap items-center gap-3">
        <h1 className="font-display text-2xl font-bold text-mill-ink">Public-safe receipt</h1>
        <IllustrativeBadge />
      </div>
      <p className="mb-6 text-sm leading-relaxed text-mill-muted">
        This is the shareable view of a governed action. It shows the action, roles, versions and evidence references only —
        never the underlying Mill data. Its status is shown honestly.
      </p>

      {state === "loading" && (
        <div className="flex items-center gap-2 text-mill-muted" data-testid="receipt-loading"><Loader2 className="h-4 w-4 animate-spin" /> Loading receipt…</div>
      )}
      {state === "notfound" && (
        <div className="rounded-2xl border border-stone-200 bg-white p-8 text-center" data-testid="receipt-notfound">
          <SearchX className="mx-auto h-8 w-8 text-mill-muted" />
          <p className="mt-3 font-semibold text-mill-ink">Receipt not found</p>
          <p className="mt-1 text-sm text-mill-muted">No receipt exists for this reference. Generate one from a journey's governed action.</p>
        </div>
      )}
      {state === "done" && <KatlasReceiptCard receipt={receipt} showLink={false} />}
    </div>
  );
}
